import { render, staticRenderFns } from "./CourseCodeAssignment.vue?vue&type=template&id=e5972a70"
import script from "./CourseCodeAssignment.vue?vue&type=script&lang=js"
export * from "./CourseCodeAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports